import React from 'react';
import Logo from './Logo';

export default function Footer() {
  return (
    <footer id="help">
      <div className="kido-footer-main">
        <div className="kido-footer-brand"><Logo /></div>
        <p></p>
      </div>
      <div className="kido-footer-contact">
        <span>დაგვიკავშირდი</span>
        <a href="tel:+995555123456">+995 555 12 34 56</a>
        <a href="mailto:hello@kido.ge">hello@kido.ge</a>
      </div>
      <div className="kido-footer-socials" aria-label="Social media">
        <a href="https://wa.me/995555123456" target="_blank" rel="noreferrer">WhatsApp</a>
        <a href="https://facebook.com" target="_blank" rel="noreferrer">Facebook</a>
        <a href="https://instagram.com" target="_blank" rel="noreferrer">Instagram</a>
      </div>
    </footer>
  );
}
